import React, { useEffect, useRef } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { StyledBox } from './UberCallback.styled';
import {
  initiatePartnerDriverEnrollmentRequest,
  loginPartnerDriverRequest,
  mapInitiatePartnerDriverEnrollment,
} from '../../src/helpers/partnerClient';
import { useRouter } from 'next/router';
import { useConfig, useErrorPage } from '../../lib/hooks';
import { isPhoenixUberEnrollmentEnabled } from '../../src/helpers/isPhoenixEnrollmentEnabled';

export default function UberCallBack() {
  const errorPage = useErrorPage();
  const config = useConfig();
  const router = useRouter();
  const hasRequested = useRef(false);

  useEffect(() => {
    const authorizationCode = router.query.code;

    if (hasRequested.current || !router.isReady || !authorizationCode || Array.isArray(authorizationCode)) {
      return;
    }

    hasRequested.current = true;

    const enroll = isPhoenixUberEnrollmentEnabled()
      ? initiatePartnerDriverEnrollmentRequest({
          promotionRef: config.promotion.ref,
          authorizationCode,
          originPartnerPlatform: 'uber',
        }).then(mapInitiatePartnerDriverEnrollment)
      : loginPartnerDriverRequest({
          promotionRef: config.promotion.ref,
          authorizationCode,
          platformName: 'uber',
        });

    enroll
      .then((result) => {
        router.push(
          {
            pathname: `/register`,
            query: {
              promotionCode: result.promotionCode,
              promotionType: result.promotionType,
              ...(isPhoenixUberEnrollmentEnabled() ? { promotionRef: result.promotionRef } : {}),
              campaignRef: result.campaignRef,
            },
          },
          undefined,
          { locale: router.locale },
        );
      })
      .catch(() => {
        errorPage('', 'We are unable to confirm your driver details at this time.');
      });
  }, [config.promotion.ref, errorPage, router]);

  return (
    <StyledBox>
      <CircularProgress />
    </StyledBox>
  );
}
